import { Stack, Switch, Typography, useTheme } from "@mui/material";

type Props = {
	label: string;
	checked: boolean;
	disabled: boolean;
	onChange: (next: boolean) => void;
};

export const NotificationToggleItem = ({
	label,
	checked,
	disabled,
	onChange,
}: Props) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			px={1.6}
			py={1.2}
			minHeight={48}
		>
			<Typography
				variant="body1"
				color={disabled ? theme.palette.text.disabled : theme.palette.grey[700]}
				flex={1}
			>
				{label}
			</Typography>
			<Switch
				checked={checked}
				disabled={disabled}
				onChange={(_event, next) => onChange(next)}
				slotProps={{ input: { "aria-label": label } }}
			/>
		</Stack>
	);
};
